module.exports = __webpack_public_path__ + "static/media/mst_logo.de42ce41.svg";